import { render, staticRenderFns } from "./CBProposalLosses.vue?vue&type=template&id=42f25da0"
import script from "./CBProposalLosses.vue?vue&type=script&lang=js"
export * from "./CBProposalLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports